import { createFileRoute } from '@tanstack/react-router';

import { StuckSetupPage } from '@/features/admin-terminal/components/stuck-setup';

/** Paying clinics with no ad spend, and the setup step each is stuck on. */
export const Route = createFileRoute('/_admin/admin/stuck-setup')({
  component: StuckSetupPage,
});
